export default __webpack_public_path__ + "static/teaser-alltours2x-befae21f1ae50972714c3c161af62e1b.jpg";